import { useDispatch } from 'react-redux';
import { Screen, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useAppSelector } from '~/hooks';
import { BackButton, CardSpinner } from '~/commonComponents';
import logoDarkIcon from '../../../images/logos/logoDarkIcon.svg';
import { POST_PP_JOB, postPermanentHireJob } from '../../../actions';
import { createLoadingSelector } from '../../../api/selectors';
import PPView from './PPView';

export default function PPScreen() {
  const loadingSelector = createLoadingSelector([POST_PP_JOB]);
  const isLoading = useAppSelector((state) => loadingSelector(state));
  const dispatch = useDispatch();

  if (isLoading) {
    return <CardSpinner />;
  }
  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton />}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
          <img src={logoDarkIcon} style={{ width: 40 }} alt="GoTu" />
          <Typography size="heading_2" bold textAlign="center" color={colors.neutral[600]}>
            Permanent Hire
          </Typography>
          <Typography size="body_large" textAlign="center" color={colors.neutral[600]}>
            GoTu now offers a turn-key recruiting service to help you fill your open positions fast.
          </Typography>
        </div>
      </Screen.Header>
      <Screen.Body>
        <PPView btnSubmitClicked={(jobData) => dispatch(postPermanentHireJob({ jobData }))} />
      </Screen.Body>
    </Screen>
  );
}
